import styled from "styled-components";
import { desktop, tablet } from "./BreakPoints";

export const ResponsiveColumns = styled.div<{columnCount:number, tabletColumnCount?:number, mobileColumnCount?:number, rowGap?:number, columnGap?:number, fullWidth?:boolean}>`
    display: grid;
    ${props => props.fullWidth ? 'width:100%;' : ''};

    row-gap: ${props => `${props.rowGap || 0}px`};
    column-gap: ${props => `${props.columnGap || 0}px`};
    
    grid-template-columns: ${props => `repeat(${props.columnCount}, 1fr)`};
    
    @media (max-width: ${desktop}px) {
        grid-template-columns: ${props => `repeat(${props.tabletColumnCount || props.columnCount}, 1fr)`};
    }
    
    @media (max-width: ${tablet}px) {
        grid-template-columns: ${props => `repeat(${props.mobileColumnCount || props.columnCount}, 1fr)`};
    }
`;